import { Suspense, lazy, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { getHerramienta } from '@/tools/registro';
import { ErrorBoundary } from '@/components/ErrorBoundary';

/**
 * Punto de montaje genérico de herramientas (patrón DLC). La ruta
 * `/h/:herramientaId` (declarada UNA vez en App.tsx) busca la herramienta en el
 * registro y renderiza su componente con carga diferida y aislamiento. Añadir
 * una herramienta interna nueva NO vuelve a tocar App.tsx: se registra su
 * `cargar` en src/tools/registro.ts y queda accesible en `/h/<id>`.
 */
export function HerramientaHost() {
  const { herramientaId } = useParams();
  const h = herramientaId ? getHerramienta(herramientaId) : undefined;

  const Lazy = useMemo(() => (h?.cargar ? lazy(h.cargar) : null), [h]);

  if (!h || !Lazy) {
    return (
      <div className="ld-card">
        <p className="muted" style={{ margin: 0 }}>
          Herramienta no encontrada o aún sin componente propio.
        </p>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <Suspense
        fallback={
          <p className="muted" style={{ display: 'flex', alignItems: 'center', fontSize: 13 }}>
            <span className="ld-spinner" aria-hidden />
            Cargando herramienta…
          </p>
        }
      >
        <Lazy />
      </Suspense>
    </ErrorBoundary>
  );
}
